import React from "react";
import { NavLink } from "react-router-dom";
import {
  FileText,
  Clipboard,
  ShoppingCart,
  BarChart2,
  BookOpen,
  Gift,
  Grid,
} from "react-feather";

const navItems = [
  {
    key: "sales-register",
    label: "Sales Register",
    helper: "Bills & settlements",
    to: "/pos/bill-list",
    icon: <FileText size={15} />,
  },
  {
    key: "kots",
    label: "KOTs",
    helper: "Pending & completed",
    to: "/pos/reports/pending-kots",
    icon: <Clipboard size={15} />,
  },
  {
    key: "daily-sales",
    label: "Daily Sales",
    helper: "Business-date sales",
    to: "/pos/reports/daily-sales",
    icon: <ShoppingCart size={15} />,
  },
  {
    key: "sales-analysis",
    label: "Sales Analysis",
    helper: "Trends & mix",
    to: "/pos/reports/sales-analysis",
    icon: <BarChart2 size={15} />,
  },
  {
    key: "tax-report",
    label: "Tax Report",
    helper: "GST/tax review",
    to: "/pos/reports/tax-report",
    icon: <BookOpen size={15} />,
  },
  {
    key: "complementary",
    label: "Complementary",
    helper: "Audit views",
    to: "/pos/reports/complementary-bills",
    icon: <Gift size={15} />,
  },
  {
    key: "reports",
    label: "Reports",
    helper: "All POS reports",
    to: "/pos/reports",
    icon: <Grid size={15} />,
  },
];

const PosModuleTopNav = ({ activeKey = "sales-register", maxItems = 7 }) => {
  const visibleItems = navItems.slice(0, maxItems);

  return (
    <nav className="ns-pos-module-topnav" aria-label="POS module quick navigation">
      <style>{`
        .ns-pos-module-topnav {
          min-width: 0;
          display: flex;
          align-items: center;
          gap: 7px;
          overflow-x: auto;
          overflow-y: hidden;
          padding: 4px;
          border-radius: 18px;
          background: rgba(255, 255, 255, 0.82);
          border: 1px solid rgba(15, 23, 42, 0.08);
          box-shadow: 0 12px 30px rgba(15, 23, 42, 0.055);
          scrollbar-width: none;
          max-width: min(780px, 100%);
        }

        .ns-pos-module-topnav::-webkit-scrollbar {
          display: none;
        }

        .ns-pos-module-link {
          min-width: 118px;
          height: 48px;
          border-radius: 14px;
          border: 1px solid rgba(15, 23, 42, 0.08);
          background: #ffffff;
          color: #334155;
          text-decoration: none !important;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 7px 10px;
          transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease, background 0.16s ease;
          flex: 0 0 auto;
        }

        .ns-pos-module-link:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
          border-color: rgba(37, 99, 235, 0.22);
          color: #0f172a;
        }

        .ns-pos-module-link.active,
        .ns-pos-module-link.is-active {
          background: linear-gradient(135deg, #1d4ed8, #2563eb);
          border-color: #1d4ed8;
          color: #ffffff;
          box-shadow: 0 14px 30px rgba(37, 99, 235, 0.20);
        }

        .ns-pos-module-icon {
          width: 28px;
          height: 28px;
          border-radius: 10px;
          background: #eff6ff;
          color: #1d4ed8;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 auto;
        }

        .ns-pos-module-link.active .ns-pos-module-icon,
        .ns-pos-module-link.is-active .ns-pos-module-icon {
          background: rgba(255, 255, 255, 0.18);
          color: #ffffff;
        }

        .ns-pos-module-copy {
          min-width: 0;
          display: grid;
          gap: 1px;
        }

        .ns-pos-module-copy strong {
          color: inherit;
          font-size: 0.76rem;
          font-weight: 950;
          line-height: 1.1;
          white-space: nowrap;
        }

        .ns-pos-module-copy span {
          color: currentColor;
          opacity: 0.74;
          font-size: 0.62rem;
          font-weight: 850;
          line-height: 1.1;
          white-space: nowrap;
        }

        @media (max-width: 1120px) {
          .ns-pos-module-topnav {
            width: 100%;
            max-width: 100%;
          }

          .ns-pos-module-link {
            min-width: 112px;
          }
        }
      `}</style>

      {visibleItems.map((item) => {
        const isActive = item.key === activeKey;

        return (
          <NavLink
            key={item.key}
            to={item.to}
            className={({ isActive: routeActive }) =>
              `ns-pos-module-link ${isActive || routeActive ? "is-active" : ""}`
            }
          >
            <span className="ns-pos-module-icon">{item.icon}</span>
            <span className="ns-pos-module-copy">
              <strong>{item.label}</strong>
              <span>{item.helper}</span>
            </span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default PosModuleTopNav;
